export default __webpack_public_path__ + "static/media/logoheader.2d3dadef.png";